import type { ILineups, ILineupsPlayer, IItemString } from "~src/interfaces/basketball";

export const convertLineupsPlayerData = (data: any) => {
  // 0: Duration of presence
  // 1: ^Hits-Shots
  // 2: ^Three-pointers made-Three-point shots
  // 3: ^Free throws made-Free throw shots
  // 4: ^Offensive rebound
  // 5: ^Defensive rebound
  // 6: ^Total rebounds
  // 7: ^Assists
  // 8: ^Steals
  // 9: ^Blocks
  // 10: ^Number of errors
  // 11: ^Individual fouls
  // 12: ^+/- value
  // 13: ^Score
  // 14: ^Whether to play (1-to play，0-not to play)
  // 15: ^Whether on the field (0-on the field，1-not on the field) (used in the game)
  // 16: ^Whether it is a substitute (1-substitute，0-starter)  (String type)
  const playerData = data.split("^");

  return {
    duration_of_presence: playerData[0],
    hits_shots: playerData[1],
    three_pointers: playerData[2],
    free_throws: playerData[3],
    offensive_rebound: playerData[4],
    defensive_rebound: playerData[5],
    total_rebounds: parseInt(playerData[6]),
    assists: parseInt(playerData[7]),
    steals: parseInt(playerData[8]),
    blocks: parseInt(playerData[9]),
    number_of_errors: parseInt(playerData[10]),
    individual_fouls: parseInt(playerData[11]),
    value: parseInt(playerData[12]),
    score: parseInt(playerData[13]),
    whether_to_play: playerData[14],
    whether_on_the_field: playerData[15],
    whether_it_is_a_substitute: playerData[16],
  }
}

export const convertLineupsPlayer = (player: any) => {
  const id = player[0];
  const name = player[1];
  const logo = player[2];
  const jersey_nmber = player[3];
  const data = convertLineupsPlayerData(player[4]);

  return {
    id,
    name,
    logo,
    jersey_nmber,
    data
  }
}

export const convertLineupsData = (lineups: any) => {
  const home: ILineupsPlayer[] = [];
  const away: ILineupsPlayer[] = [];
  for(const player of lineups.players[0]) {
    home.push(convertLineupsPlayer(player));
  }
  for(const player of lineups.players[1]) {
    away.push(convertLineupsPlayer(player));
  }

  // sort data by score, total_rebounds, assists
  home.sort((a, b) => {
    if(a.data.score !== b.data.score) {
      return b.data.score - a.data.score;
    }
    if(a.data.total_rebounds !== b.data.total_rebounds) {
      return b.data.total_rebounds - a.data.total_rebounds;
    }
    return b.data.assists - a.data.assists;
  });
  away.sort((a, b) => {
    if(a.data.score !== b.data.score) {
      return b.data.score - a.data.score;
    }
    if(a.data.total_rebounds !== b.data.total_rebounds) {
      return b.data.total_rebounds - a.data.total_rebounds;
    }
    return b.data.assists - a.data.assists;
  });

  return {
    id: lineups.id,
    players: {
      home,
      away
    },
  }
}

